import styled, { css } from 'styled-components';
import { getElevationTransition, elevation } from '../Styles/Utils/elevation.js';

const Container = styled.div `
    padding: ${(props) => props.theme.spacers['L']};
    background-color: ${(props) => props.theme.colors.background.white};
    border: 2px solid ${(props) => props.$borderColor || props.theme.colors.stroke.lighterGrey};
    border-radius: 8px;
    ${getElevationTransition(true)}
    color: ${(props) => props.theme.colors.text.darkerGrey};

    ${(props) => !props.$highlight &&
    props.$defaultHover &&
    css `
            cursor: pointer;
            &:hover {
                background-color: ${props.theme.colors.background.white};
                ${elevation(1, true)}
            }
        `}

    ${(props) => !props.$highlight &&
    props.$elevated &&
    css `
            background-color: ${props.theme.colors.background.white};
            ${elevation(1, true)}
        `}

    ${(props) => props.$highlight &&
    css `
            background-color: ${props.theme.colors.hover.lighterGrey};
            border-color: ${props.theme.colors.stroke.lighterGrey};
        `}
`;

export { Container };
